import Vue from 'vue'
import VueRouter from 'vue-router'
/* import Home from '../views/Home.vue' */
import Login from '@/views/Login.vue'
import Outside from '@/views/Outside.vue'
import ThirdLogin from '@/views/ThirdLogin.vue'
import Main from '@/views/Main.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
		path: '/',
		name: 'Login',
		component: Login,
		meta:{
			title:'互联网舆情监测预警系统|舆情监测平台|微博舆情系统|舆情系统-云目信息(www.hnroger.com)'
		}
	},
	{
		path: '/outside',
		name: 'outSide',
		component: Outside
	},
	{
		path: '/ThirdLogin',
		name: 'ThirdLogin',
		component: ThirdLogin
	},
	{
		path: '/test/test',
		name: 'test',
		component: () => import('@/views/test/Test.vue'),
	},
	{
		path: '/main',
		name: 'Main',
		component: Main,
		redirect: '/home/home', // 设置默认打开的页面
		meta: {
			title:'互联网舆情监测预警系统|舆情监测平台|微博舆情系统|舆情系统-云目信息(www.hnroger.com)',
			login: true
		},
		children: [{
				path: '/home/home',
				name: 'home',
				component: () => import( /* webpackChunkName: "home" */ '@/views/home/Home.vue'),
				meta: {
					name: '首页',
					login: true,
					title:'互联网舆情监测预警系统|舆情监测平台|微博舆情系统|舆情系统-云目信息(www.hnroger.com)'
				}
			},
			{
				path: '/monitoring/monitoring',
				name: 'monitoring',
				component: () => import( /* webpackChunkName: "monitoring" */ '@/views/monitoring/Monitoring.vue'),
				meta: {
					name: '舆情监测',
					login: true,
					title:'互联网舆情监测预警系统|舆情监测平台|微博舆情系统|舆情系统-云目信息(www.hnroger.com)'
				}
			},
			{
				path: '/earlyWarning/earlyWarning',
				name: 'earlyWarning',
				component: () => import( /* webpackChunkName: "earlyWarning" */ '@/views/earlyWarning/EarlyWarning.vue'),
				meta: {
					name: '预警舆情',
					login: true,
					title:'预警舆情'
				}
			},
			{
				path: '/statistics/statistics',
				name: 'statistics',
				component: () => import( /* webpackChunkName: "statistics" */ '@/views/statistics/Statistics.vue'),
				meta: {
					name: '统计分析',
					login: true,
					title:'统计分析'
				}
			}, {
				path: '/search/search',
				name: 'search',
				component: () => import( /* webpackChunkName: "search" */ '@/views/search/Search.vue'),
				meta: {
					name: '舆情搜索',
					login: true,
					title:'舆情搜索'
				}
			}, {
				path: '/system/system',
				name: 'system',
				component: () => import( /* webpackChunkName: "system" */ '@/views/system/System.vue'),
				meta: {
					name: '预警设置',
					title: '预警设置',
					login: true,
					
				}
			},
			{
				path: '/changePassword/changePassword',
				name: 'changePassword',
				component: () => import( /* webpackChunkName: "changePassword" */ '@/views/system/ChangePassword.vue'),
				meta: {
					name: '修改密码',
					title: '修改密码',
					login: true
				}
			},
			{
				path: '/systemAuth/systemAuth',
				name: 'systemAuth',
				component: () => import( /* webpackChunkName: "SystemAuth" */ '@/views/system/SystemAuth.vue'),
				meta: {
					name: '权限管理',
					title: '权限管理',
					login: true
				}
			}
		]
	}
]




const router = new VueRouter({
	mode: 'history',
	  base:'/',
	routes: routes
})
const setTitle = (title) => {
  // 如果该路由没有设置title值，则前一个是 undefined || 前一个值为false时直接返回admin
  // console.log(window.document);
  window.document.title = title || '互联网舆情监测预警系统|舆情监测平台|微博舆情系统|舆情系统-云目信息(www.hnroger.com)'
}

router.beforeEach((to, from, next) => {
	to.meta && setTitle(to.meta.title)
	if(to.path==='/' || to.path==='/outside'|| to.path==='/test/test' || to.path==='/ThirdLogin'){
		next();
	} else {
		if (!router.app.$cookies.get("isLogin")) {
			
			router.push('/')
		} else {
			
			next();
		}
	}
})
 
export default router
